import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import WrappedQuill from 'components/Quill';
import { makeStyles } from '@material-ui/styles';
import { signatureToolbarModules } from 'constants/pitch';

const useStyles = makeStyles(() => ({
  description: {
    display: 'block',
    marginBottom: 16,
    fontSize: 12,
  },
}));

const EmailSignatureModal = ({
  open, onBackdropClick, onConfirm, onCancel, initialSignature, email,
}) => {
  const editor = useRef();
  const handleConfirm = () => {
    onConfirm(editor.current.getEditor().root.innerHTML);
  };
  const classes = useStyles();
  return (
    <ConfirmationModal
      open={open}
      onBackdropClick={onBackdropClick}
      title={`Email Signature for ${email}`}
      confirmLabel="Save"
      confirmBtnColor="primary"
      cancelLabel="Cancel"
      onConfirmClick={handleConfirm}
      onCancelClick={onCancel}
      size="medium"
    >
      <span className={classes.description}>
        Your signature is added at the end of your email. You can include your name, job title, and company name
      </span>
      <WrappedQuill
        attachRef={(ref) => {
          editor.current = ref;
        }}
        modules={signatureToolbarModules}
        defaultValue={initialSignature}
        placeholder="Type your signature here"
        isSignatureModal
      />
    </ConfirmationModal>
  );
};

EmailSignatureModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onBackdropClick: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  initialSignature: PropTypes.string,
  email: PropTypes.string,
};

EmailSignatureModal.defaultProps = {
  initialSignature: '',
  email: '',
};

export default EmailSignatureModal;
